$(function() {
    let page_elements = {
        category: $("#category"),
        type: $("#type"),
        level: $("#level"),
        exam_type: $("#examType"),
        practice_material: $("#inlineCheckbox3"),
        mocktest: $("#inlineCheckbox4")
    };

   

    initializePlugins();
});

function initializePlugins() {
    $(".ui-select2-select[multiple]").select2({
        minimumResultsForSearch: -1,
        closeOnSelect: false,
        placeholder: $(this).attr("data-placeholder")
    });
    $(".ui-select2-select:not([multiple])").select2({
        minimumResultsForSearch: -1,
        placeholder: $(this).attr("data-placeholder")
    });
    $(".ui-select2-select").on("select2:opening", function(e) {
        $("body").addClass("js-ui-select-check-box");
    });

    $(".ui-select2-select").on("select2:closeing", function(e) {
        $("body").removeClass("js-ui-select-check-box");
    });
}

///////////////////////////////////////////
////////// filter course ///////////////////
///////////////////////////////////////////

/**
 * Course filter
 * @param {JSON} event
 */
function filterCourse(event) {
    event.preventDefault();

    let form_data = {
            category: $("#category").val(),
            type: $("#type").val(),
            level: $("#level").val(),
            exam_type: $("#examType").val(),
            query: $("#js-course-search").val(),
            practice_material: $("#inlineCheckbox3:checked").val(),
            mocktest: $("#inlineCheckbox4:checked").val(),
            page: $("#page").val()
        },
        form_action = $(event.target)
            .parents("form")
            .attr("action");

    $(".all-course").addClass("hide");
    $(".filter-course").removeClass("hide");

    $.ajax({
        url: form_action,
        type: "GET",
        data: form_data,
        statusCode: {
            411: function () {
                $('div.modal').removeClass('show');
                window.location.href = '/profile';
            }
        },
        success: successFilterpHandler.bind(this),
        error: errorFilterHandler.bind(this)
    });
}

/**
 * Success handle for filter course
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function successFilterpHandler(response) {
    console.log(response);
    if (response.success) {
        $(".all-course").removeClass("hide");
        $(".filter-course").addClass("hide");
        $(".latest-coure").empty();
        console.log("page", response.data.page);
        if (response.data.page == "home") {
            $(".filter-data").removeClass("hide");
            $("#current-data-div")
                .data("owl.carousel")
                .destroy();
            $(".current-data-div").empty();

            let count = response.data.result.data.length,
                show_msg = "No result found!";

            if (count == 0) {
                console.log(show_msg);
                $("#searchCourse .main-division .current-data-div").append(
                    show_msg
                );
            } else {
                let show_load_more_btn=false
                let current_result_count = response.data.result.to;
                let total_result_count = response.data.result.total;
                (current_result_count < total_result_count)?show_load_more_btn=true:show_load_more_btn=false
                $.each(response.data.result.data, function(i, value) {
                    if (i >= 0) {
                        let html = "";
                        $.each(value.courseCategory, function(i, category) {
                            html =
                                html +
                                '<li class="ui-' +
                                category.category.name.toLowerCase() +
                                '-tag">' +
                                category.category.name +
                                "</li>";
                        });

                        let courseLessonsComment = " Lesson</li>";
                        if (
                            value.course_details.total_lessons &&
                            value.course_details.total_lessons > 1
                        ) {
                            courseLessonsComment = " Lessons</li>";
                        }
                        $(
                            "#searchCourse .main-division .current-data-div"
                        ).append(
                            '<a href="' +
                                value.course_student_url +
                                '" class="item js-course  filter-data" id="filter-data">' +
                                '<div class="ui-ser-img-wrap">' +
                                '<img class="img-fluid js-lazyload" data-src="' +
                                value.preview_image_url +
                                '" alt="' +
                                value.title +
                                '"src="' +
                                value.preview_image_url +
                                '">' +
                                (value.actual_price == 0
                                    ? '<span class="ui-free-course-badge">Free course</span>'
                                    : "") +
                                "</div>" +
                                '<ul class="ui-tag-list-color">' +
                                html +
                                "</ul>" +
                                '<ul class="ui-courses-tag-list ui-first-courses-tag-list">' +
                                "<li>" +
                                response.data.examTypeList[value.exam_type] +
                                "</li>" +
                                "<li>" +
                                response.data.levelList[value.level] +
                                "</li>" +
                                "<li>" +
                                response.data.typeList[value.type] +
                                " Course" +
                                "</li>" +
                                "</ul>" +
                                '<h5 class="ui-h5 title">' +
                                value.title +
                                "</h5>" +
                                '<ul class="ui-courses-tag-list">' +
                                (value.course_details.total_lessons
                                    ? "<li>" +
                                      value.course_details.total_lessons +
                                      courseLessonsComment
                                    : "") +
                                (value.practice_tests_count
                                    ? `<li>${ value.practice_tests_count } Practice tests</li>`
                                    : "") +
                                (value.mock_tests_count
                                    ? `<li>${ value.mock_tests_count } Mock tests</li>`
                                    : "") +
                                "</ul>" +
                                "</a>"
                        );
                        if (show_load_more_btn) {
                            $(".see-more").hide()
                            $(".js-see-more").show()
                        }
                        else {
                            $(".js-see-more").hide()
                        }
                    }
                });
            }
            $("#current-data-div").owlCarousel({
                loop: true,
                margin: 20,
                responsive: {
                    0: {
                        items: 1.2,
                        dots: false,
                        nav: false
                    },
                    400: {
                        items: 2,
                        dots: false,
                        nav: false
                    },
                    900: {
                        items: 3,
                        dots: false,
                        nav: true
                    },
                    1200: {
                        items: 4,
                        dots: false,
                        nav: true
                    }
                }
            });
        } else {
            let count = response.data.result.total,
                show_msg = "No result found!";

            if (count > 0) {
                show_msg = "Showing " + count + " Total Results";
            }
            $("#resultCount").html(show_msg);
            let show_load_more_btn=false
            let current_result_count = response.data.result.to;
            let total_result_count = response.data.result.total;
            (current_result_count < total_result_count)?show_load_more_btn=true:show_load_more_btn=false

            $.each(response.data.result.data, function(i, value) {
                if (i >= 0) {
                    let html = "";
                    $.each(value.courseCategory, function(i, category) {
                        html =
                            html +
                            '<li class="ui-' +
                            category.category.name.toLowerCase() +
                            '-tag">' +
                            category.category.name +
                            "</li>";
                    });

                    let courseLessonsComment = " Lesson</li>";
                    if (value.course_details.total_lessons) {
                        if (value.course_details.total_lessons > 1) {
                            courseLessonsComment = " Lessons</li>";
                        }
                    }

                    $("#course-data").append(
                        "" +
                            '<div class="col-lg-3 col-md-6 col-sm-6 ui-custom-col">' +
                            '<a href="' +
                            value.course_student_url +
                            '"class="item ">' +
                            '<div class="ui-ser-img-wrap">' +
                            '<img class="img-fluid js-lazyload" data-src="' +
                            value.preview_image_url +
                            '" alt="' +
                            value.title +
                            '" src="' +
                            value.preview_image_url +
                            '">' +
                            (value.actual_price == 0
                                ? '<span class="ui-free-course-badge">Free course</span>'
                                : "") +
                            "</div>" +
                            '<ul class="ui-tag-list-color category-type">' +
                            html +
                            "</ul>" +
                            '<ul class="ui-courses-tag-list ui-first-courses-tag-list">' +
                            "<li>" +
                            response.data.levelList[value.level] +
                            "</li>" +
                            "<li>" +
                            response.data.typeList[value.type] +
                            " Course" +
                            "</li>" +
                            "</ul>" +
                            '<h5 class="ui-h5">' +
                            value.title +
                            "</h5>" +
                            '<ul class="ui-courses-tag-list">' +
                            (value.course_details.total_lessons
                                ? "<li>" +
                                  value.course_details.total_lessons +
                                  courseLessonsComment
                                : "") +
                            (value.practice_tests_count
                                ? "<li>Practice tests</li>"
                                : "") +
                            (value.mock_tests_count
                                ? "<li>Mock tests</li>"
                                : "") +
                            "</ul>" +
                            "</a>" +
                            "</div>"
                    );

                    if (show_load_more_btn) {
                        $(".see-more").hide()
                        $(".js-see-more").show()
                        $(".js-see-more").attr("data-total", response.data.result.last_page);
                    }
                    else {
                        $(".js-see-more").hide()
                    }
                }
            });
        }
    }
}

/**
 * Error handle for filter course
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 * @param {JSON} response
 */
function errorFilterHandler(response) {
    if (response.status == 422) {
        $(".js-common-error")
            .text("All inputs are required")
            .removeClass("hide");
        $.each(response.responseJSON.errors, function(key, value) {
            $('[name="' + key + '"]')
                .addClass("is-invalid")
                .next()
                .removeClass("hide")
                .html(value.join("<br>"));
        });
    } else {
        $(".js-common-error")
            .text("Something went wrong!!! Please try again")
            .removeClass("hide");
    }
}

/**
 * Pagination Handling
 *
 * @author Niyas <niyas@webandcrafts.in>
 *
 */

$(".see-more").click(function() {
    let data_div = $($(this).data("div")), //div to append
        page = $(this).data("page"), //get the next page #
        page_href = window.location.href;
        (page_href.includes("?")) ? page_href +="&page="+page:page_href =page_href+= "?page=" + page;
         //complete URL

       let html;
    $.get(page_href, function(response) {
        //append data

        html = $(response)
            .find("#course-data")
            .html();
        data_div.append(html);
    });

    $(this).data("page", parseInt(page) + 1); //update page #
    if (page == $(this).data("total")) {
        $(".see-more").hide();
    }
});

$(".js-see-more").click(function() {
    let data_div = $($(this).data("div")), //div to append
        page = $(this).data("page"), //get the next page #

        page_href = window.location.href;
        (page_href.includes("?")) ? page_href +="&page="+page:page_href =page_href+= "?page=" + page;
         //complete URL
        // page_href = window.location.href + "?page=" + page, //complete URL
        let html;
    $.get(page_href, function(response) {
        //append data

        html = $(response)
            .find("#course-data")
            .html();
        data_div.append(html);
    });

    $(this).data("page", parseInt(page) + 1); //update page #
    if (page == $(this).data("total")) {
        $(".js-see-more").hide();
    }
});

$(".js-course-explore").on("click", function() {
    // let selected_category = $('#category').val(),
    //     selected_type = $('#type').val(),
    //     selected_level = $('#level').val(),
    //     PT_checked = ($("input[name='practice_material']").is(':checked'))? $("input[name='practice_material']").val() : '',
    //     MT_checked = ($("input[name='mocktest']").is(':checked'))?$("input[name='mocktest']").val():'';
    let parameter_append = "";

    if ($("#category").val().length > 0) {
        parameter_append =
            parameter_append + "category=" + $("#category").val() + "&";
    }
    if ($("#type").val().length > 0) {
        parameter_append = parameter_append + "type=" + $("#type").val() + "&";
    }
    if ($("#level").val().length > 0) {
        parameter_append =
            parameter_append + "level=" + $("#level").val() + "&";
    }
    if ($("input[name='practice_material']").is(":checked")) {
        parameter_append =
            parameter_append +
            "practice_material=" +
            $("input[name='practice_material']").val() +
            "&";
    }
    if ($("input[name='mocktest']").is(":checked")) {
        parameter_append =
            parameter_append + "mocktest=" + $("input[name='mocktest']").val();
    }

    if (parameter_append) {
        if (parameter_append.charAt(parameter_append.length - 1) == "&") {
            parameter_append = parameter_append.slice(0, -1);
        }
        // window.location.href = $('#url').val()+ '/course/explore-more?category='+selected_category
        // +'&type='+selected_type+'&level='+selected_level+'&pt='+PT_checked+'&mt='+MT_checked;

        window.location.href =
            $("#url").val() + "/course/explore-more?" + parameter_append;
    } else {
        window.location.href = $("#url").val() + "/course/search-result";
    }

    // let new_url = $('#url').val()+ '/search-result/';
    // console.log('new_url', new_url);
    // console.log('selected_type', selected_type);
    console.log("selected_level", selected_level);
    console.log("PT_checked", PT_checked);
    console.log("MT_checked", MT_checked);
});


$(document).ready(function() {
    $('#examType').on('change', function() {
        var selectedExamTypes = $(this).val(); // Get selected exam types (could be an array)
        var typeList = {
            '2': ['ALL','ACADEMIC', 'PTE_CORE'],
            '1': ['ALL','ACADEMIC', 'GENERAL'],
            '3': ['OET_NURSE'],
            'ALL':['ALL','ACADEMIC', 'GENERAL','PTE_CORE','OET_NURSE']
        };
        
        if (selectedExamTypes) {
            var typeSelect = $('#type');
            typeSelect.empty();
        }
        var uniqueOptions = new Set(); 
       
        $.each(selectedExamTypes, function(index, examType) {
            var options = typeList[examType];
            if (options) { 
                options.forEach(option => uniqueOptions.add(option));
            }
        });
         // Append default option if no exam type is selected
        if(uniqueOptions.size === 0){
            var options = typeList['ALL'];
            options.forEach(option => uniqueOptions.add(option));
        }
        uniqueOptions.forEach(option => {
            typeSelect.append($('<option></option>').val(option).text(option));
        });
        typeSelect.on('change', function() {
            // Check if the selected value is 'ALL'
            if ($(this).val() === 'ALL') {
                // Reload the page
                window.location.reload();
            }
        });
    });
});

